module.exports = __webpack_public_path__ + "assets/montserrat-bold.e136ef6f82173292ad0c92cbcd4d68edeeb32cc4e7fc81791ca421285463693c.woff2";